// src/main.tsx
import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";

// 1) Import Tailwind first…
import "./styles/index.css";
// 2) …then your dashboard override so it wins
import "./styles/dashboard-override.css";

// 3) Theme provider for live theming
import { ThemeProvider } from "@/theme/ThemeProvider";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <HashRouter>
        <App />
      </HashRouter>
    </ThemeProvider>
  </React.StrictMode>
);
